import Avatar from '@core/components/Avatar';
import { TranslateFn } from '@core/hooks/useTranslate';
import { User } from '@core/interfaces';
import { getUserInfor } from '@store/selectors/user';
import Auth from '@utils/helpers/auth';
import { Menu } from 'antd';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import Popup from '../Popup';
import HeaderDropdown from './HeaderDropdown';
import MypageServices from '@root/modules/Sellers/Mypage/services/mypage';

export type GlobalHeaderRightProps = {
  menu?: boolean;
  t: TranslateFn;
  adminLogout: () => void;
  appRole: any;
};

const AvatarDropdown: React.FC<GlobalHeaderRightProps> = ({
  menu,
  t,
  adminLogout,
  appRole
}) => {
  const [userInfor, setUserInfor] = useState<string>('');
  const dataUser = useSelector(getUserInfor());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dropdown, setDropdown] = useState(false);

  const infoUser = localStorage.getItem('infoUser');
  const infoUserWarehouse = localStorage.getItem('infoUserWarehouse');

  const handleOk = () => {
    setIsModalOpen(false);
    adminLogout();
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const handleModal = () => {
    setIsModalOpen(true);
  };

  const handleDropdown = () => {
    setDropdown(!dropdown);
  };
  console.log(appRole);
  const menuHeaderDropdown = (
    <>
      {dropdown ? (
        <Menu
          className="avatar-dropdown__menu"
          selectedKeys={[]}
          onClick={handleDropdown}
        >
          {/* {appRole !== 'busk-admin' ? ( */}
          <Link
            to={
              appRole === 'warehouse-admin'
                ? '/admin/seller/page-warehouse'
                : appRole === 'seller-admin'
                ? '/admin/seller/mypage'
                : appRole === 'busk-admin'
                ? '/admin/busk/mypage'
                : '/admin/forwarder/my'
            }
          >
            <Menu.Item key="mypage">
              {appRole === 'warehouse-admin' ? 'My Account' : '마이페이지'}
            </Menu.Item>
          </Link>
          {/* ) : null} */}
          <Menu.Item key="logout" onClick={handleModal}>
            {appRole === 'warehouse-admin' ? 'Logout' : '로그아웃'}
          </Menu.Item>
        </Menu>
      ) : null}
    </>
  );

  useEffect(() => {
    if (Auth.getToken()) {
      let info = appRole === 'warehouse-admin' ? infoUserWarehouse : infoUser;
      if (!!info) {
        setUserInfor(info);
      } else {
        getInfo();
      }
    }
  }, []);

  const getInfo = async () => {
    try {
      let infoUserNow = await MypageServices.getSellerID();
      let nameUser = infoUserNow?.data?.email.split('@')[0];
      setUserInfor(nameUser);
      localStorage.setItem('infoUser', nameUser);
    } catch (e) {
      setUserInfor('');
    }
  };

  return (
    <>
      <HeaderDropdown
        className="right"
        trigger={['click']}
        overlay={menuHeaderDropdown}
      >
        <span className="header-dropdown__action account">
          <div className="flex-box" onClick={() => setDropdown(true)}>
            <Avatar size="small" shape="circle" />
            <span className="name anticon">{userInfor}</span>
          </div>

          <Popup
            styleBackground="white"
            styleColor="#2A2D51"
            textCancel={appRole === 'warehouse-admin' ? '' : '취소'}
            textOk={appRole === 'warehouse-admin' ? '' : '확인'}
            visible={isModalOpen}
            title={
              appRole === 'warehouse-admin'
                ? 'Do you want to log out?'
                : '로그아웃 하시겠습니까?'
            }
            action_oke={handleOk}
            action_cancel={handleCancel}
          />
        </span>
      </HeaderDropdown>
    </>
  );
};
export default AvatarDropdown;
